export default "__VITE_ASSET__e5463926__"